import { Component, OnInit } from '@angular/core';
import { Trip } from '../../models/trip';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { getTripDurationInMin } from '../../utils/commons-utils';
import * as moment from 'moment';

@Component({
  selector: 'app-trips-details',
  templateUrl: './trips-details.component.html',
  styleUrls: ['./trips-details.component.css']
})
export class TripsDetailsComponent implements OnInit {

  trip : Trip;

  constructor(public activeModal : NgbActiveModal) { }

  ngOnInit() {
    getTripDurationInMin(this.trip);
    this.trip.tripStartTime = moment.utc(this.trip.tripStartTime ).local().toDate();
    this.trip.tripEndTime = moment.utc(this.trip.tripEndTime ).local().toDate();
  }

}



// WEBPACK FOOTER //
// ./src/app/trips/trips-details/trips-details.component.ts